/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkloadRouteImport } from './routes/workload'
import { Route as RoadmapRouteImport } from './routes/roadmap'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as MyTasksRouteImport } from './routes/my-tasks'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as FilesRouteImport } from './routes/files'
import { Route as DashboardsRouteImport } from './routes/dashboards'
import { Route as CapacityRouteImport } from './routes/capacity'
import { Route as AllocationsRouteImport } from './routes/allocations'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TeamIndexRouteImport } from './routes/team.index'
import { Route as TasksIndexRouteImport } from './routes/tasks.index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as TeamUserIdRouteImport } from './routes/team.$userId'
import { Route as TasksTaskIdRouteImport } from './routes/tasks.$taskId'
import { Route as SettingsWorkspaceRouteImport } from './routes/settings/workspace'
import { Route as SettingsSecurityRouteImport } from './routes/settings/security'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as SettingsMembersRouteImport } from './routes/settings/members'
import { Route as SettingsConnectRouteImport } from './routes/settings/connect'
import { Route as SettingsAppearanceRouteImport } from './routes/settings/appearance'
import { Route as SettingsAccountRouteImport } from './routes/settings/account'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as ProjectsNewRouteImport } from './routes/projects/new'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminInvitesRouteImport } from './routes/admin/invites'
import { Route as ProjectsProjectIdRouteRouteImport } from './routes/projects/$projectId/route'
import { Route as ProjectsProjectIdIndexRouteImport } from './routes/projects/$projectId/index'
import { Route as ProjectsProjectIdWikiRouteImport } from './routes/projects/$projectId/wiki'
import { Route as ProjectsProjectIdTimelineRouteImport } from './routes/projects/$projectId/timeline'
import { Route as ProjectsProjectIdTableRouteImport } from './routes/projects/$projectId/table'
import { Route as ProjectsProjectIdSettingsRouteImport } from './routes/projects/$projectId/settings'
import { Route as ProjectsProjectIdRequirementsRouteImport } from './routes/projects/$projectId/requirements'
import { Route as ProjectsProjectIdReportsRouteImport } from './routes/projects/$projectId/reports'
import { Route as ProjectsProjectIdMilestonesRouteImport } from './routes/projects/$projectId/milestones'
import { Route as ProjectsProjectIdMembersRouteImport } from './routes/projects/$projectId/members'
import { Route as ProjectsProjectIdListRouteImport } from './routes/projects/$projectId/list'
import { Route as ProjectsProjectIdGanttRouteImport } from './routes/projects/$projectId/gantt'
import { Route as ProjectsProjectIdFilesRouteImport } from './routes/projects/$projectId/files'
import { Route as ProjectsProjectIdEpicsRouteImport } from './routes/projects/$projectId/epics'
import { Route as ProjectsProjectIdDocsRouteImport } from './routes/projects/$projectId/docs'
import { Route as ProjectsProjectIdCalendarRouteImport } from './routes/projects/$projectId/calendar'
import { Route as ProjectsProjectIdActivityRouteImport } from './routes/projects/$projectId/activity'
import { Route as ProjectsProjectIdTasksNewRouteImport } from './routes/projects/$projectId/tasks/new'

const WorkloadRoute = WorkloadRouteImport.update({
  id: '/workload',
  path: '/workload',
  getParentRoute: () => rootRouteImport,
} as any)
const RoadmapRoute = RoadmapRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioRoute = PortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => rootRouteImport,
} as any)
const MyTasksRoute = MyTasksRouteImport.update({
  id: '/my-tasks',
  path: '/my-tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const FilesRoute = FilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardsRoute = DashboardsRouteImport.update({
  id: '/dashboards',
  path: '/dashboards',
  getParentRoute: () => rootRouteImport,
} as any)
const CapacityRoute = CapacityRouteImport.update({
  id: '/capacity',
  path: '/capacity',
  getParentRoute: () => rootRouteImport,
} as any)
const AllocationsRoute = AllocationsRouteImport.update({
  id: '/allocations',
  path: '/allocations',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamIndexRoute = TeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamUserIdRoute = TeamUserIdRouteImport.update({
  id: '/team/$userId',
  path: '/team/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksTaskIdRoute = TasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWorkspaceRoute = SettingsWorkspaceRouteImport.update({
  id: '/settings/workspace',
  path: '/settings/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSecurityRoute = SettingsSecurityRouteImport.update({
  id: '/settings/security',
  path: '/settings/security',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/settings/notifications',
  path: '/settings/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMembersRoute = SettingsMembersRouteImport.update({
  id: '/settings/members',
  path: '/settings/members',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsConnectRoute = SettingsConnectRouteImport.update({
  id: '/settings/connect',
  path: '/settings/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/settings/appearance',
  path: '/settings/appearance',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/settings/account',
  path: '/settings/account',
  getParentRoute: () => rootRouteImport,
} as any)
const RTokenRoute = RTokenRouteImport.update({
  id: '/r/$token',
  path: '/r/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminInvitesRoute = AdminInvitesRouteImport.update({
  id: '/admin/invites',
  path: '/admin/invites',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRouteRoute = ProjectsProjectIdRouteRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdIndexRoute = ProjectsProjectIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsProjectIdRouteRoute,
} as any)
const ProjectsProjectIdWikiRoute = ProjectsProjectIdWikiRouteImport.update({
  id: '/wiki',
  path: '/wiki',
  getParentRoute: () => ProjectsProjectIdRouteRoute,
} as any)
const ProjectsProjectIdTimelineRoute =
  ProjectsProjectIdTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => ProjectsProjectIdRouteRoute,
  } as any)
const ProjectsProjectIdTableRoute = ProjectsProjectIdTableRouteImport.update({
  id: '/table',
  path: '/table',
  getParentRoute: () => ProjectsProjectIdRouteRoute,
} as any)
const ProjectsProjectIdSettingsRoute =
  ProjectsProjectIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ProjectsProjectIdRouteRoute,
  } as any)
const ProjectsProjectIdRequirementsRoute =
  ProjectsProjectIdRequirementsRouteImport.update({
    id: '/requirements',
    path: '/requirements',
    getParentRoute: () => ProjectsProjectIdRouteRoute,
  } as any)
const ProjectsProjectIdReportsRoute =
  ProjectsProjectIdReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => ProjectsProjectIdRouteRoute,
  } as any)
const ProjectsProjectIdMilestonesRoute =
  ProjectsProjectIdMilestonesRouteImport.update({
    id: '/milestones',
    path: '/milestones',
    getParentRoute: () => ProjectsProjectIdRouteRoute,
  } as any)
const ProjectsProjectIdMembersRoute =
  ProjectsProjectIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => ProjectsProjectIdRouteRoute,
  } as any)
const ProjectsProjectIdListRoute = ProjectsProjectIdListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => ProjectsProjectIdRouteRoute,
} as any)
const ProjectsProjectIdGanttRoute = ProjectsProjectIdGanttRouteImport.update({
  id: '/gantt',
  path: '/gantt',
  getParentRoute: () => ProjectsProjectIdRouteRoute,
} as any)
const ProjectsProjectIdFilesRoute = ProjectsProjectIdFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => ProjectsProjectIdRouteRoute,
} as any)
const ProjectsProjectIdEpicsRoute = ProjectsProjectIdEpicsRouteImport.update({
  id: '/epics',
  path: '/epics',
  getParentRoute: () => ProjectsProjectIdRouteRoute,
} as any)
const ProjectsProjectIdDocsRoute = ProjectsProjectIdDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => ProjectsProjectIdRouteRoute,
} as any)
const ProjectsProjectIdCalendarRoute =
  ProjectsProjectIdCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => ProjectsProjectIdRouteRoute,
  } as any)
const ProjectsProjectIdActivityRoute =
  ProjectsProjectIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => ProjectsProjectIdRouteRoute,
  } as any)
const ProjectsProjectIdTasksNewRoute =
  ProjectsProjectIdTasksNewRouteImport.update({
    id: '/tasks/new',
    path: '/tasks/new',
    getParentRoute: () => ProjectsProjectIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/allocations': typeof AllocationsRoute
  '/capacity': typeof CapacityRoute
  '/dashboards': typeof DashboardsRoute
  '/files': typeof FilesRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/my-tasks': typeof MyTasksRoute
  '/portfolio': typeof PortfolioRoute
  '/profile': typeof ProfileRoute
  '/roadmap': typeof RoadmapRoute
  '/workload': typeof WorkloadRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteRouteWithChildren
  '/admin/invites': typeof AdminInvitesRoute
  '/admin/users': typeof AdminUsersRoute
  '/projects/new': typeof ProjectsNewRoute
  '/r/$token': typeof RTokenRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/connect': typeof SettingsConnectRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/workspace': typeof SettingsWorkspaceRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/team/$userId': typeof TeamUserIdRoute
  '/admin/': typeof AdminIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/team/': typeof TeamIndexRoute
  '/projects/$projectId/activity': typeof ProjectsProjectIdActivityRoute
  '/projects/$projectId/calendar': typeof ProjectsProjectIdCalendarRoute
  '/projects/$projectId/docs': typeof ProjectsProjectIdDocsRoute
  '/projects/$projectId/epics': typeof ProjectsProjectIdEpicsRoute
  '/projects/$projectId/files': typeof ProjectsProjectIdFilesRoute
  '/projects/$projectId/gantt': typeof ProjectsProjectIdGanttRoute
  '/projects/$projectId/list': typeof ProjectsProjectIdListRoute
  '/projects/$projectId/members': typeof ProjectsProjectIdMembersRoute
  '/projects/$projectId/milestones': typeof ProjectsProjectIdMilestonesRoute
  '/projects/$projectId/reports': typeof ProjectsProjectIdReportsRoute
  '/projects/$projectId/requirements': typeof ProjectsProjectIdRequirementsRoute
  '/projects/$projectId/settings': typeof ProjectsProjectIdSettingsRoute
  '/projects/$projectId/table': typeof ProjectsProjectIdTableRoute
  '/projects/$projectId/timeline': typeof ProjectsProjectIdTimelineRoute
  '/projects/$projectId/wiki': typeof ProjectsProjectIdWikiRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/tasks/new': typeof ProjectsProjectIdTasksNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/allocations': typeof AllocationsRoute
  '/capacity': typeof CapacityRoute
  '/dashboards': typeof DashboardsRoute
  '/files': typeof FilesRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/my-tasks': typeof MyTasksRoute
  '/portfolio': typeof PortfolioRoute
  '/profile': typeof ProfileRoute
  '/roadmap': typeof RoadmapRoute
  '/workload': typeof WorkloadRoute
  '/admin/invites': typeof AdminInvitesRoute
  '/admin/users': typeof AdminUsersRoute
  '/projects/new': typeof ProjectsNewRoute
  '/r/$token': typeof RTokenRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/connect': typeof SettingsConnectRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/workspace': typeof SettingsWorkspaceRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/team/$userId': typeof TeamUserIdRoute
  '/admin': typeof AdminIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/tasks': typeof TasksIndexRoute
  '/team': typeof TeamIndexRoute
  '/projects/$projectId/activity': typeof ProjectsProjectIdActivityRoute
  '/projects/$projectId/calendar': typeof ProjectsProjectIdCalendarRoute
  '/projects/$projectId/docs': typeof ProjectsProjectIdDocsRoute
  '/projects/$projectId/epics': typeof ProjectsProjectIdEpicsRoute
  '/projects/$projectId/files': typeof ProjectsProjectIdFilesRoute
  '/projects/$projectId/gantt': typeof ProjectsProjectIdGanttRoute
  '/projects/$projectId/list': typeof ProjectsProjectIdListRoute
  '/projects/$projectId/members': typeof ProjectsProjectIdMembersRoute
  '/projects/$projectId/milestones': typeof ProjectsProjectIdMilestonesRoute
  '/projects/$projectId/reports': typeof ProjectsProjectIdReportsRoute
  '/projects/$projectId/requirements': typeof ProjectsProjectIdRequirementsRoute
  '/projects/$projectId/settings': typeof ProjectsProjectIdSettingsRoute
  '/projects/$projectId/table': typeof ProjectsProjectIdTableRoute
  '/projects/$projectId/timeline': typeof ProjectsProjectIdTimelineRoute
  '/projects/$projectId/wiki': typeof ProjectsProjectIdWikiRoute
  '/projects/$projectId': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/tasks/new': typeof ProjectsProjectIdTasksNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/allocations': typeof AllocationsRoute
  '/capacity': typeof CapacityRoute
  '/dashboards': typeof DashboardsRoute
  '/files': typeof FilesRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/my-tasks': typeof MyTasksRoute
  '/portfolio': typeof PortfolioRoute
  '/profile': typeof ProfileRoute
  '/roadmap': typeof RoadmapRoute
  '/workload': typeof WorkloadRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteRouteWithChildren
  '/admin/invites': typeof AdminInvitesRoute
  '/admin/users': typeof AdminUsersRoute
  '/projects/new': typeof ProjectsNewRoute
  '/r/$token': typeof RTokenRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/connect': typeof SettingsConnectRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/workspace': typeof SettingsWorkspaceRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/team/$userId': typeof TeamUserIdRoute
  '/admin/': typeof AdminIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/team/': typeof TeamIndexRoute
  '/projects/$projectId/activity': typeof ProjectsProjectIdActivityRoute
  '/projects/$projectId/calendar': typeof ProjectsProjectIdCalendarRoute
  '/projects/$projectId/docs': typeof ProjectsProjectIdDocsRoute
  '/projects/$projectId/epics': typeof ProjectsProjectIdEpicsRoute
  '/projects/$projectId/files': typeof ProjectsProjectIdFilesRoute
  '/projects/$projectId/gantt': typeof ProjectsProjectIdGanttRoute
  '/projects/$projectId/list': typeof ProjectsProjectIdListRoute
  '/projects/$projectId/members': typeof ProjectsProjectIdMembersRoute
  '/projects/$projectId/milestones': typeof ProjectsProjectIdMilestonesRoute
  '/projects/$projectId/reports': typeof ProjectsProjectIdReportsRoute
  '/projects/$projectId/requirements': typeof ProjectsProjectIdRequirementsRoute
  '/projects/$projectId/settings': typeof ProjectsProjectIdSettingsRoute
  '/projects/$projectId/table': typeof ProjectsProjectIdTableRoute
  '/projects/$projectId/timeline': typeof ProjectsProjectIdTimelineRoute
  '/projects/$projectId/wiki': typeof ProjectsProjectIdWikiRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/tasks/new': typeof ProjectsProjectIdTasksNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/allocations'
    | '/capacity'
    | '/dashboards'
    | '/files'
    | '/inbox'
    | '/login'
    | '/my-tasks'
    | '/portfolio'
    | '/profile'
    | '/roadmap'
    | '/workload'
    | '/projects/$projectId'
    | '/admin/invites'
    | '/admin/users'
    | '/projects/new'
    | '/r/$token'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/connect'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/security'
    | '/settings/workspace'
    | '/tasks/$taskId'
    | '/team/$userId'
    | '/admin/'
    | '/projects/'
    | '/tasks/'
    | '/team/'
    | '/projects/$projectId/activity'
    | '/projects/$projectId/calendar'
    | '/projects/$projectId/docs'
    | '/projects/$projectId/epics'
    | '/projects/$projectId/files'
    | '/projects/$projectId/gantt'
    | '/projects/$projectId/list'
    | '/projects/$projectId/members'
    | '/projects/$projectId/milestones'
    | '/projects/$projectId/reports'
    | '/projects/$projectId/requirements'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/table'
    | '/projects/$projectId/timeline'
    | '/projects/$projectId/wiki'
    | '/projects/$projectId/'
    | '/projects/$projectId/tasks/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/allocations'
    | '/capacity'
    | '/dashboards'
    | '/files'
    | '/inbox'
    | '/login'
    | '/my-tasks'
    | '/portfolio'
    | '/profile'
    | '/roadmap'
    | '/workload'
    | '/admin/invites'
    | '/admin/users'
    | '/projects/new'
    | '/r/$token'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/connect'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/security'
    | '/settings/workspace'
    | '/tasks/$taskId'
    | '/team/$userId'
    | '/admin'
    | '/projects'
    | '/tasks'
    | '/team'
    | '/projects/$projectId/activity'
    | '/projects/$projectId/calendar'
    | '/projects/$projectId/docs'
    | '/projects/$projectId/epics'
    | '/projects/$projectId/files'
    | '/projects/$projectId/gantt'
    | '/projects/$projectId/list'
    | '/projects/$projectId/members'
    | '/projects/$projectId/milestones'
    | '/projects/$projectId/reports'
    | '/projects/$projectId/requirements'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/table'
    | '/projects/$projectId/timeline'
    | '/projects/$projectId/wiki'
    | '/projects/$projectId'
    | '/projects/$projectId/tasks/new'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/allocations'
    | '/capacity'
    | '/dashboards'
    | '/files'
    | '/inbox'
    | '/login'
    | '/my-tasks'
    | '/portfolio'
    | '/profile'
    | '/roadmap'
    | '/workload'
    | '/projects/$projectId'
    | '/admin/invites'
    | '/admin/users'
    | '/projects/new'
    | '/r/$token'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/connect'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/security'
    | '/settings/workspace'
    | '/tasks/$taskId'
    | '/team/$userId'
    | '/admin/'
    | '/projects/'
    | '/tasks/'
    | '/team/'
    | '/projects/$projectId/activity'
    | '/projects/$projectId/calendar'
    | '/projects/$projectId/docs'
    | '/projects/$projectId/epics'
    | '/projects/$projectId/files'
    | '/projects/$projectId/gantt'
    | '/projects/$projectId/list'
    | '/projects/$projectId/members'
    | '/projects/$projectId/milestones'
    | '/projects/$projectId/reports'
    | '/projects/$projectId/requirements'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/table'
    | '/projects/$projectId/timeline'
    | '/projects/$projectId/wiki'
    | '/projects/$projectId/'
    | '/projects/$projectId/tasks/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  AllocationsRoute: typeof AllocationsRoute
  CapacityRoute: typeof CapacityRoute
  DashboardsRoute: typeof DashboardsRoute
  FilesRoute: typeof FilesRoute
  InboxRoute: typeof InboxRoute
  LoginRoute: typeof LoginRoute
  MyTasksRoute: typeof MyTasksRoute
  PortfolioRoute: typeof PortfolioRoute
  ProfileRoute: typeof ProfileRoute
  RoadmapRoute: typeof RoadmapRoute
  WorkloadRoute: typeof WorkloadRoute
  ProjectsProjectIdRouteRoute: typeof ProjectsProjectIdRouteRouteWithChildren
  AdminInvitesRoute: typeof AdminInvitesRoute
  AdminUsersRoute: typeof AdminUsersRoute
  ProjectsNewRoute: typeof ProjectsNewRoute
  RTokenRoute: typeof RTokenRoute
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsConnectRoute: typeof SettingsConnectRoute
  SettingsMembersRoute: typeof SettingsMembersRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsSecurityRoute: typeof SettingsSecurityRoute
  SettingsWorkspaceRoute: typeof SettingsWorkspaceRoute
  TasksTaskIdRoute: typeof TasksTaskIdRoute
  TeamUserIdRoute: typeof TeamUserIdRoute
  AdminIndexRoute: typeof AdminIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  TasksIndexRoute: typeof TasksIndexRoute
  TeamIndexRoute: typeof TeamIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workload': {
      id: '/workload'
      path: '/workload'
      fullPath: '/workload'
      preLoaderRoute: typeof WorkloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roadmap': {
      id: '/roadmap'
      path: '/roadmap'
      fullPath: '/roadmap'
      preLoaderRoute: typeof RoadmapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio': {
      id: '/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof PortfolioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-tasks': {
      id: '/my-tasks'
      path: '/my-tasks'
      fullPath: '/my-tasks'
      preLoaderRoute: typeof MyTasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/files': {
      id: '/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof FilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboards': {
      id: '/dashboards'
      path: '/dashboards'
      fullPath: '/dashboards'
      preLoaderRoute: typeof DashboardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capacity': {
      id: '/capacity'
      path: '/capacity'
      fullPath: '/capacity'
      preLoaderRoute: typeof CapacityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/allocations': {
      id: '/allocations'
      path: '/allocations'
      fullPath: '/allocations'
      preLoaderRoute: typeof AllocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/': {
      id: '/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof TeamIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/$userId': {
      id: '/team/$userId'
      path: '/team/$userId'
      fullPath: '/team/$userId'
      preLoaderRoute: typeof TeamUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/workspace': {
      id: '/settings/workspace'
      path: '/settings/workspace'
      fullPath: '/settings/workspace'
      preLoaderRoute: typeof SettingsWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/security': {
      id: '/settings/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof SettingsSecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/members': {
      id: '/settings/members'
      path: '/settings/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof SettingsMembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/connect': {
      id: '/settings/connect'
      path: '/settings/connect'
      fullPath: '/settings/connect'
      preLoaderRoute: typeof SettingsConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/settings/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$token': {
      id: '/r/$token'
      path: '/r/$token'
      fullPath: '/r/$token'
      preLoaderRoute: typeof RTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/invites': {
      id: '/admin/invites'
      path: '/admin/invites'
      fullPath: '/admin/invites'
      preLoaderRoute: typeof AdminInvitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/': {
      id: '/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof ProjectsProjectIdIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/wiki': {
      id: '/projects/$projectId/wiki'
      path: '/wiki'
      fullPath: '/projects/$projectId/wiki'
      preLoaderRoute: typeof ProjectsProjectIdWikiRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/timeline': {
      id: '/projects/$projectId/timeline'
      path: '/timeline'
      fullPath: '/projects/$projectId/timeline'
      preLoaderRoute: typeof ProjectsProjectIdTimelineRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/table': {
      id: '/projects/$projectId/table'
      path: '/table'
      fullPath: '/projects/$projectId/table'
      preLoaderRoute: typeof ProjectsProjectIdTableRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/settings': {
      id: '/projects/$projectId/settings'
      path: '/settings'
      fullPath: '/projects/$projectId/settings'
      preLoaderRoute: typeof ProjectsProjectIdSettingsRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/requirements': {
      id: '/projects/$projectId/requirements'
      path: '/requirements'
      fullPath: '/projects/$projectId/requirements'
      preLoaderRoute: typeof ProjectsProjectIdRequirementsRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/reports': {
      id: '/projects/$projectId/reports'
      path: '/reports'
      fullPath: '/projects/$projectId/reports'
      preLoaderRoute: typeof ProjectsProjectIdReportsRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/milestones': {
      id: '/projects/$projectId/milestones'
      path: '/milestones'
      fullPath: '/projects/$projectId/milestones'
      preLoaderRoute: typeof ProjectsProjectIdMilestonesRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/members': {
      id: '/projects/$projectId/members'
      path: '/members'
      fullPath: '/projects/$projectId/members'
      preLoaderRoute: typeof ProjectsProjectIdMembersRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/list': {
      id: '/projects/$projectId/list'
      path: '/list'
      fullPath: '/projects/$projectId/list'
      preLoaderRoute: typeof ProjectsProjectIdListRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/gantt': {
      id: '/projects/$projectId/gantt'
      path: '/gantt'
      fullPath: '/projects/$projectId/gantt'
      preLoaderRoute: typeof ProjectsProjectIdGanttRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/files': {
      id: '/projects/$projectId/files'
      path: '/files'
      fullPath: '/projects/$projectId/files'
      preLoaderRoute: typeof ProjectsProjectIdFilesRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/epics': {
      id: '/projects/$projectId/epics'
      path: '/epics'
      fullPath: '/projects/$projectId/epics'
      preLoaderRoute: typeof ProjectsProjectIdEpicsRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/docs': {
      id: '/projects/$projectId/docs'
      path: '/docs'
      fullPath: '/projects/$projectId/docs'
      preLoaderRoute: typeof ProjectsProjectIdDocsRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/calendar': {
      id: '/projects/$projectId/calendar'
      path: '/calendar'
      fullPath: '/projects/$projectId/calendar'
      preLoaderRoute: typeof ProjectsProjectIdCalendarRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/activity': {
      id: '/projects/$projectId/activity'
      path: '/activity'
      fullPath: '/projects/$projectId/activity'
      preLoaderRoute: typeof ProjectsProjectIdActivityRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
    '/projects/$projectId/tasks/new': {
      id: '/projects/$projectId/tasks/new'
      path: '/tasks/new'
      fullPath: '/projects/$projectId/tasks/new'
      preLoaderRoute: typeof ProjectsProjectIdTasksNewRouteImport
      parentRoute: typeof ProjectsProjectIdRouteRoute
    }
  }
}

interface ProjectsProjectIdRouteRouteChildren {
  ProjectsProjectIdActivityRoute: typeof ProjectsProjectIdActivityRoute
  ProjectsProjectIdCalendarRoute: typeof ProjectsProjectIdCalendarRoute
  ProjectsProjectIdDocsRoute: typeof ProjectsProjectIdDocsRoute
  ProjectsProjectIdEpicsRoute: typeof ProjectsProjectIdEpicsRoute
  ProjectsProjectIdFilesRoute: typeof ProjectsProjectIdFilesRoute
  ProjectsProjectIdGanttRoute: typeof ProjectsProjectIdGanttRoute
  ProjectsProjectIdListRoute: typeof ProjectsProjectIdListRoute
  ProjectsProjectIdMembersRoute: typeof ProjectsProjectIdMembersRoute
  ProjectsProjectIdMilestonesRoute: typeof ProjectsProjectIdMilestonesRoute
  ProjectsProjectIdReportsRoute: typeof ProjectsProjectIdReportsRoute
  ProjectsProjectIdRequirementsRoute: typeof ProjectsProjectIdRequirementsRoute
  ProjectsProjectIdSettingsRoute: typeof ProjectsProjectIdSettingsRoute
  ProjectsProjectIdTableRoute: typeof ProjectsProjectIdTableRoute
  ProjectsProjectIdTimelineRoute: typeof ProjectsProjectIdTimelineRoute
  ProjectsProjectIdWikiRoute: typeof ProjectsProjectIdWikiRoute
  ProjectsProjectIdIndexRoute: typeof ProjectsProjectIdIndexRoute
  ProjectsProjectIdTasksNewRoute: typeof ProjectsProjectIdTasksNewRoute
}

const ProjectsProjectIdRouteRouteChildren: ProjectsProjectIdRouteRouteChildren =
  {
    ProjectsProjectIdActivityRoute: ProjectsProjectIdActivityRoute,
    ProjectsProjectIdCalendarRoute: ProjectsProjectIdCalendarRoute,
    ProjectsProjectIdDocsRoute: ProjectsProjectIdDocsRoute,
    ProjectsProjectIdEpicsRoute: ProjectsProjectIdEpicsRoute,
    ProjectsProjectIdFilesRoute: ProjectsProjectIdFilesRoute,
    ProjectsProjectIdGanttRoute: ProjectsProjectIdGanttRoute,
    ProjectsProjectIdListRoute: ProjectsProjectIdListRoute,
    ProjectsProjectIdMembersRoute: ProjectsProjectIdMembersRoute,
    ProjectsProjectIdMilestonesRoute: ProjectsProjectIdMilestonesRoute,
    ProjectsProjectIdReportsRoute: ProjectsProjectIdReportsRoute,
    ProjectsProjectIdRequirementsRoute: ProjectsProjectIdRequirementsRoute,
    ProjectsProjectIdSettingsRoute: ProjectsProjectIdSettingsRoute,
    ProjectsProjectIdTableRoute: ProjectsProjectIdTableRoute,
    ProjectsProjectIdTimelineRoute: ProjectsProjectIdTimelineRoute,
    ProjectsProjectIdWikiRoute: ProjectsProjectIdWikiRoute,
    ProjectsProjectIdIndexRoute: ProjectsProjectIdIndexRoute,
    ProjectsProjectIdTasksNewRoute: ProjectsProjectIdTasksNewRoute,
  }

const ProjectsProjectIdRouteRouteWithChildren =
  ProjectsProjectIdRouteRoute._addFileChildren(
    ProjectsProjectIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  AllocationsRoute: AllocationsRoute,
  CapacityRoute: CapacityRoute,
  DashboardsRoute: DashboardsRoute,
  FilesRoute: FilesRoute,
  InboxRoute: InboxRoute,
  LoginRoute: LoginRoute,
  MyTasksRoute: MyTasksRoute,
  PortfolioRoute: PortfolioRoute,
  ProfileRoute: ProfileRoute,
  RoadmapRoute: RoadmapRoute,
  WorkloadRoute: WorkloadRoute,
  ProjectsProjectIdRouteRoute: ProjectsProjectIdRouteRouteWithChildren,
  AdminInvitesRoute: AdminInvitesRoute,
  AdminUsersRoute: AdminUsersRoute,
  ProjectsNewRoute: ProjectsNewRoute,
  RTokenRoute: RTokenRoute,
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsConnectRoute: SettingsConnectRoute,
  SettingsMembersRoute: SettingsMembersRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsSecurityRoute: SettingsSecurityRoute,
  SettingsWorkspaceRoute: SettingsWorkspaceRoute,
  TasksTaskIdRoute: TasksTaskIdRoute,
  TeamUserIdRoute: TeamUserIdRoute,
  AdminIndexRoute: AdminIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  TasksIndexRoute: TasksIndexRoute,
  TeamIndexRoute: TeamIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
